"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedSites = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactWindow = require("react-window");

var _SelectedSite = _interopRequireDefault(require("./SelectedSite"));

const Row = /*#__PURE__*/React.memo(({
  index,
  data,
  style
}) => {
  const {
    selected,
    sites,
    handleClick
  } = data;
  const site = sites[selected[index]];
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(_SelectedSite.default, {
    onClick: handleClick(site),
    label: site.label
  }));
}, _reactWindow.areEqual);

const SelectedSites = ({
  sites,
  selectedSites,
  handleClick
}) => {
  const selected = Array.from(selectedSites);
  return /*#__PURE__*/React.createElement(_reactWindow.FixedSizeList, {
    height: 295,
    width: "100%",
    itemCount: selected.length,
    itemData: {
      selected,
      sites,
      handleClick
    },
    itemSize: 32
  }, Row);
};

exports.SelectedSites = SelectedSites;